import { legacyApiClient } from "../clients";
import { LegacyUser, LegacyUserGroupingDto } from "./legacyUserTypes";

export const legacyUserApi = {
  fetchUser: async (userId: string) => {
    const { data } = await legacyApiClient.request<LegacyUser>({
      url: `/users/${userId}`,
    });
    return data;
  },
  fetchUserGroupings: async (userId: string) => {
    const { data } = await legacyApiClient.request<LegacyUserGroupingDto[]>({
      url: `/users/${userId}/groupings`,
    });
    return data;
  },
};
